import { put } from 'redux-saga/effects';
import {
  getMessagesAPICall,
  putReadMessages,
  markArchive,
  revokeAccessToken,
} from '../../services/App.service';
import { getMsgsSuccess, markMsgArchiveSuccess } from './Notifications.action';
import { pollUnreadNotificationsResponded } from '../side-bar/SideBar.actions';

export function* getMessagesSaga() {
  try {
    const response = yield getMessagesAPICall();
    if (response.status === 200) {
      const ids = response.json.map((item) => item.id);
      const req = JSON.stringify({ read: true, notificationIDs: ids });
      const response2 = yield putReadMessages(req);
      if (response2.status === 200) {
        yield put(pollUnreadNotificationsResponded({ msgsCount: 0 }));
      }
      yield put(getMsgsSuccess({ notifications: response.json }));
    }
  } catch (error) {
    console.log('error getting messages - ', error);
  }
}

export function* archiveMsgSaga(action) {
  const { notificationId } = action.payload;
  try {
    const response = yield markArchive(notificationId);
    if (response.ok) {
      yield put(markMsgArchiveSuccess({ notification: response.json }));
    }
  } catch (error) {
    console.log('error archiving msg - ', error);
  }
}

export function* revokeAccessTokenSaga() {
  try {
    yield revokeAccessToken();
  } catch (error) {
    // failure scenario can be added if required
  }
}
